import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row p-2" }
const _hoisted_2 = { class: "col-12 d-flex" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  class: "font-weight-bold",
  style: {"margin-bottom":"0"}
}
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "col-12 text-right" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "col-12 mb-3" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-4 text-center" }
const _hoisted_13 = { class: "mb-0 txt-bold" }
const _hoisted_14 = {
  style: {"border-color":"#e4eaf0","border-style":"solid","border-width":"0 1px"},
  class: "col-4 text-center"
}
const _hoisted_15 = { class: "mb-0 txt-bold" }
const _hoisted_16 = { class: "col-4 text-center" }
const _hoisted_17 = { class: "mb-0 txt-bold" }
const _hoisted_18 = { class: "col-12 text-center text-secondary p-2" }
const _hoisted_19 = { class: "text-success" }

import { ref } from "vue";
import AlertPopup from "../popup/AlertPopup.vue";
import ChartCustome from "../chart/ChartCustome.vue";
import { normalizeFloat } from "@app/@turnkeyidutils";
import { NTag, NTooltip, NIcon, NPopover } from "naive-ui";
import { useRouter } from "vue-router";

type IProps = {
  data?: any;
  type?: string;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'InvestorCard',
  props: {
    data: {},
    type: {}
  },
  setup(__props: any) {

const isOpen = ref(false);
const router = useRouter();
const props = __props;

function countJoinFee(data) {
  if (data.manager_detail && data.manager_detail.IncentiveAccounts) {
    const initialValue = 0;
    const joinFee = data.manager_detail.IncentiveAccounts;

    const sumWithInitial = joinFee.reduce((accumulator, currentValue) => accumulator + currentValue.ManagementFee, initialValue);
    return sumWithInitial;
  }
  return 0;
}

function countPerformanceFee(data) {
  if (data.manager_detail && data.manager_detail.IncentiveAccounts) {
    const initialValue = 0;
    const joinFee = data.manager_detail.IncentiveAccounts;

    const sumWithInitial = joinFee.reduce((accumulator, currentValue) => accumulator + currentValue.IncentiveFee, initialValue);
    return sumWithInitial;
  }
  return 0;
}

function toLink(data) {
  if (!data.isUserInvestment) {
    router.push(`/pamm/investor-account/money-managers/${data.id ? data.id : data._id}`);
  } else {
    if (data.statusInvestment === `pending` || data.statusInvestment === `pending-disconnect`) {
      router.push(`/pamm/investor-account/money-managers/${data.id ? data.id : data._id}`);
      return;
    }
    router.push(`/pamm/investor-account/my-investment/${data.idUserInvestment}`);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toLink(_ctx.data))),
      class: "investor-card h-100 p-2"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.data.persona && _ctx.data.persona.profile_pic_url ? _ctx.data.persona.profile_pic_url : '/assets/img/avatar.svg',
            class: "rounded-circle bg-secondary mr-3",
            alt: _ctx.data?.manager_detail?.Name,
            style: {"width":"40px","height":"40px"}
          }, null, 8, _hoisted_3),
          _createElementVNode("div", null, [
            _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.data?.manager_detail?.Name || "-"), 1),
            _createElementVNode("small", _hoisted_5, "ID : " + _toDisplayString(_ctx.data?.manager_detail?.Id || "-"), 1),
            (_ctx.data.statusInvestment)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createVNode(_unref(NTag), {
                    class: "ml-2",
                    round: "",
                    size: "small",
                    bordered: false,
                    type: _ctx.data.statusInvestment === 'connected' ? 'success' : _ctx.data.status === 'disconnected' ? 'error' : _ctx.data.status === 'pending' ? 'warning' : 'default'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.data.statusInvestment), 1)
                    ]),
                    _: 1
                  }, 8, ["type"]),
                  (_ctx.data.statusInvestment === `pending-disconnect` || _ctx.data.statusInvestment === `pending`)
                    ? (_openBlock(), _createBlock(_unref(NPopover), {
                        key: 0,
                        trigger: "hover",
                        placement: "right"
                      }, {
                        trigger: _withCtx(() => [
                          _createVNode(_unref(NIcon), { class: "ml-2" }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1)
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createElementVNode("span", null, "please wait for money manager approval", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("small", { class: "text-secondary" }, "Profit", -1)),
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.data?.manager_detail?.TotalProfit < 0 ? 'text-danger' : 'text-success', "mb-0 txt-bold"])
          }, [
            _createElementVNode("img", {
              src: _ctx.data?.manager_detail?.TotalProfit < 0 ? `/assets/img/trending_down.svg` : '/assets/img/trending_up.svg',
              alt: "trending"
            }, null, 8, _hoisted_8),
            _createTextVNode(" " + _toDisplayString(_ctx.data?.manager_detail?.TotalProfit) + " USD ", 1)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(ChartCustome, {
            type: "lineChart",
            data: _ctx.data.performanceHistory,
            "is-profit": _ctx.data?.manager_detail?.TotalProfit >= 0
          }, null, 8, ["data", "is-profit"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("small", _hoisted_13, _toDisplayString(_unref(normalizeFloat)(countJoinFee(_ctx.data), {
                  toFixed: 2,
                })) + " % ", 1),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _cache[6] || (_cache[6] = _createElementVNode("small", { class: "text-secondary" }, "Join Fee", -1))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("small", _hoisted_15, _toDisplayString(_unref(normalizeFloat)(countPerformanceFee(_ctx.data), {
                  toFixed: 2,
                })) + " % ", 1),
              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
              _cache[8] || (_cache[8] = _createElementVNode("small", { class: "text-secondary" }, "Performance Fee", -1))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("small", _hoisted_17, _toDisplayString(_ctx.data?.penalty_setting?.period_setting?.minimum_day_invest || 0) + " Days ", 1),
              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
              _cache[10] || (_cache[10] = _createElementVNode("small", { class: "text-secondary" }, "Trading Period", -1))
            ])
          ])
        ]),
        _createElementVNode("small", _hoisted_18, [
          _cache[11] || (_cache[11] = _createTextVNode(" Minimum Investment Start From ")),
          _createElementVNode("b", _hoisted_19, _toDisplayString(_unref(normalizeFloat)(_ctx.data?.manager_detail?.MinInvestment || 0, {
              toFixed: 2,
            })) + " USD", 1)
        ])
      ])
    ]),
    _createVNode(AlertPopup, {
      "is-open": isOpen.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = $event))
    }, null, 8, ["is-open"])
  ], 64))
}
}

})